import { render, staticRenderFns } from "./to-do-history.vue?vue&type=template&id=6f4d4216&scoped=true"
import script from "./to-do-history.vue?vue&type=script&lang=js"
export * from "./to-do-history.vue?vue&type=script&lang=js"
import style0 from "./to-do-history.vue?vue&type=style&index=0&id=6f4d4216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4d4216",
  null
  
)

export default component.exports